import styled from 'styled-components';
import VideoContentContainer from 'components/NewOneBoard/VideoInfo/common/VideoContentContainer';

const StyledVideoContentContainer = styled(VideoContentContainer)`
  gap: 14px;
`;

export default StyledVideoContentContainer;
